<div class="appointment" [ngClass]="typeClass">
  <div class="info">
    <span class="time">{{ time }}</span>

    <div class="flex-1 details">
      <span class="flex-1">{{ label }}</span>

      <ng-container *ngIf="description">
        <span class="flex-1">{{ description }}</span>
      </ng-container>
    </div>
  </div>
</div>
